var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 149,
    viewBox: "0 0 127 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.4951,
    y: 33.1343,
    width: 72,
    height: 100,
    rx: 8,
    transform: "rotate(2.5 41.4951 33.1343)",
    fill: "#2C2C2C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.95789,
    y: 29.1759,
    width: 72,
    height: 100,
    rx: 8,
    transform: "rotate(-7.5 1.95789 29.1759)",
    fill: "#363636"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0021 37.1075C2.42539 32.727 5.50897 28.7084 9.88944 28.1317L65.4104 20.8222C69.7908 20.2455 73.8094 23.3291 74.3861 27.7096L76.344 42.5812L4.95999 51.9791L3.0021 37.1075Z",
    fill: "#434343"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8662,
    y: 22.7773,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(82.5 88.8662 22.7773)",
    fill: "#5E5E5E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4696,
    y: 6.21155,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(-7.5 61.4696 6.21155)",
    fill: "#5E5E5E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 79.0472,
    y: 8.94055,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(37.5 79.0472 8.94055)",
    fill: "#5E5E5E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4222,
    y: 55.0312,
    width: 58,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 12.4222 55.0312)",
    fill: "#505050"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0327,
    y: 74.8601,
    width: 58,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 15.0327 74.8601)",
    fill: "#505050"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6432,
    y: 94.689,
    width: 58,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 17.6432 94.689)",
    fill: "#505050"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4664,
    y: 62.9628,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 13.4664 62.9628)",
    fill: "#434343"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0769,
    y: 82.7916,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 16.0769 82.7916)",
    fill: "#434343"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6875,
    y: 102.621,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 18.6875 102.621)",
    fill: "#434343"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.936ac6c2.svg";
export { ForwardRef as ReactComponent };